<script>
    export default {
        mounted: function(){
            var order = this;

            Event.$emit('summaryNeedsUpdate', order.$refs.products.$refs, false);

            Event.$on("productsQuantitiesChanged", function(products, product){
                Event.$emit('summaryNeedsUpdate', order.$refs.products.$refs, product);
            });
        },
        methods: {
            breakpoint: function(breakpoint){
                return window.breakpoint(breakpoint);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/app/components/orders/order.vue